import React, { useContext } from 'react';
import { createFileRoute, useParams } from '@tanstack/react-router';
import { AppContext } from 'context/app';
import { WebRTCProvider } from 'context/webRTC';
import { LeavesContext } from 'context/leaves';
import { Loading } from 'components/common/Loading';
import { FocusedView } from 'layout/camera/FocusedView';
import { filterLeavesByDeviceType, getDeviceLeafById } from 'modules/leaves';
const CameraFocusedComopnent = () => {
  const {
    camera
  } = useParams({
    strict: false
  });
  const {
    deviceOrder
  } = useContext(AppContext);
  const {
    leafStore,
    loading
  } = useContext(LeavesContext);
  const leaves = leafStore.read();
  if (loading) {
    return <Loading />;
  }
  if (leaves && camera) {
    const cameraLeaves = filterLeavesByDeviceType(leaves, ['camera', 'doorbell']);
    const orderedCameraLeaves = deviceOrder.map(id => getDeviceLeafById(cameraLeaves, id)).filter(leaf => leaf !== null);
    return <WebRTCProvider>
        <FocusedView leafId={camera} deviceLeaves={orderedCameraLeaves} />
      </WebRTCProvider>;
  }
};
export const Route = createFileRoute('/$camera')({
  component: CameraFocusedComopnent
  // errorComponent: Error5xx,
});
if (import.meta.hot) {
  import.meta.hot.accept(newModule => {
    if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
      newModule.Route.clone(Route);
    }
  });
}